/**
 * open-minicart-on-add.js
 * -----------------------------------------------------------------------
 * Opens the theme's mini-cart automatically after a product is
 * successfully added to the cart.
 *
 * HOW TO USE:
 * 1. Upload this file as a theme asset:
 *    Shopify admin > Online Store > Themes > Edit code > Assets > Add a new asset
 *    (name it e.g. "open-minicart-on-add.js")
 *
 * 2. Include it in theme.liquid, just before the closing </body> tag:
 *    <script src="{{ 'open-minicart-on-add.js' | asset_url }}" defer></script>
 *
 * NOTE: This theme's mini-cart is opened by clicking the element that has
 * the attribute data-action="toggle-mini-cart" (see header.liquid).
 * This script listens for successful "add to cart" requests and clicks
 * that trigger for you — it does not require editing header.liquid.
 * -----------------------------------------------------------------------
 */

(function () {
  'use strict';

  function openMiniCart() {
    var trigger = document.querySelector('[data-action="toggle-mini-cart"]');
    if (!trigger) return;

    // Only open it if it isn't already open
    var isOpen = trigger.getAttribute('aria-expanded') === 'true';
    if (!isOpen) {
      trigger.click();
    }
  }

  // ---------------------------------------------------------------------
  // Method 1: Intercept fetch() calls to /cart/add.js
  // Most modern Shopify themes (including this one) submit "add to cart"
  // forms via an AJAX fetch() call to /cart/add.js. We patch fetch so we
  // can react whenever that specific request succeeds.
  // ---------------------------------------------------------------------
  var originalFetch = window.fetch;

  window.fetch = function () {
    var url = arguments[0] instanceof Request ? arguments[0].url : arguments[0];

    return originalFetch.apply(this, arguments).then(function (response) {
      if (typeof url === 'string' && url.indexOf('/cart/add') !== -1 && response.ok) {
        // Give the theme's own cart-refresh logic a brief moment to run
        // first (it usually rebuilds the mini-cart markup on this event).
        setTimeout(openMiniCart, 150);
      }
      return response;
    });
  };

  // ---------------------------------------------------------------------
  // Method 2: Fallback for XMLHttpRequest-based add-to-cart calls
  // (in case any part of the theme still uses XHR instead of fetch).
  // ---------------------------------------------------------------------
  var originalOpen = XMLHttpRequest.prototype.open;

  XMLHttpRequest.prototype.open = function (method, url) {
    if (typeof url === 'string' && url.indexOf('/cart/add') !== -1) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) {
          setTimeout(openMiniCart, 150);
        }
      });
    }
    return originalOpen.apply(this, arguments);
  };

  // ---------------------------------------------------------------------
  // Method 3: Listen for common custom events themes dispatch after
  // updating the cart (covers themes/apps using a pub/sub pattern).
  // Harmless to keep even if your theme doesn't use these.
  // ---------------------------------------------------------------------
  document.addEventListener('cart:updated', function () {
    setTimeout(openMiniCart, 150);
  });
  document.addEventListener('cart:build', function () {
    setTimeout(openMiniCart, 150);
  });
})();